export default "__VITE_ASSET__C6zrt0wm__"